import React from "react";
import { Button, CardActions, FontIcon } from "react-md";
import { Field, reduxForm } from "redux-form";
import ReactMDTextField from "../../../../common/components/ReactMDTextField";
import { required } from "../../../../common/validators";
import { countries } from "../../../../common/utils";
import ReactMDSelectField
  from "../../../../common/components/ReactMDSelectField";
import FormInputIcon from "../../../../common/components/FormInputIcon";

const MinorAddressForm = ({ handleSubmit, invalid, submitting, index }) => (
  <div>
    <section className="md-grid">
      <Field
        label="Address"
        id={`minors/${index}.address`}
        name={`minors/${index}.address`}
        type="text"
        className="md-cell md-cell--12"
        required
        component={ReactMDTextField}
        validate={[required]}
        leftIcon={<FontIcon>home</FontIcon>}
      />
      <Field
        label="Address 2"
        id={`minors/${index}.address2`}
        name={`minors/${index}.address2`}
        type="text"
        className="md-cell md-cell--12"
        component={ReactMDTextField}
        leftIcon={<FontIcon>home</FontIcon>}
      />
      <Field
        id={`minors/${index}.city`}
        name={`minors/${index}.city`}
        label="City"
        className="md-cell md-cell--6"
        required
        component={ReactMDTextField}
        validate={[required]}
        leftIcon={<FontIcon>location_city</FontIcon>}
      />
      <Field
        id={`minors/${index}.province`}
        name={`minors/${index}.province`}
        label="State / Province"
        className="md-cell md-cell--3"
        required
        component={ReactMDTextField}
        validate={[required]}
      />
      <Field
        id={`minors/${index}.postal`}
        name={`minors/${index}.postal`}
        label="Postal"
        className="md-cell md-cell--3"
        required
        component={ReactMDTextField}
        validate={[required]}
      />
      <FormInputIcon>place</FormInputIcon>
      <Field
        id={`minors/${index}.country`}
        name={`minors/${index}.country`}
        label="Country"
        placeholder="Select a Country"
        helpOnFocus
        helpText="Please select a Country"
        className="md-cell md-cell--12 md-cell--with-icon"
        menuItems={countries}
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
    </section>
    <CardActions>
      <Button
        raised
        label="Save & Continue"
        primary
        className="md-cell--right"
        disabled={submitting || invalid}
        onClick={handleSubmit}
      />
    </CardActions>
  </div>
);

MinorAddressForm.propTypes = {};
MinorAddressForm.defaultProps = {};

export default reduxForm({
  form: "minor-address-form"
})(MinorAddressForm);



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorAddress/MinorAddressForm.jsx